
import React, { Component } from 'react';
import loglevel from 'loglevel';
import get from 'lodash/get';

import ImageCropper from './image_cropper.jsx';

import { sendRequest, serializeQueryParams } from 'zoomforth_zfutils/xhr_tools.js';
import { insertOrReplaceUrlParam } from 'zoomforth_zfutils/url_utils.js';

// # Why do we need a cachebreak for the cropper?
//
// We add a cachebreaker to ensure that the *browser* does not use a locally cached
// version. The danger being that we already have a local cache of the image
// which wasnt fetched with an `Origin: ...` header. (i.e., A normal <img> tag results
// in requests which do not have an `Origin: ...` header). For such a request, the response
// will be missing an `Access-Control-Allow-Origin: *`. The browser
// will keep track of that image as "tainted" and ineligible for use in <canvas>
//
// # Why is the cachebreak at module level rather than instance level?
// 
// It is only important that we cache break *for the image cropper*,
// so we can (and should) re-use the cache break for this page editor js.
// This ensures we get a fresh response (with appropriate CORS headers)
// AND that we can re-use the cached image if the user re-opens the cropper
const TILE_CROPPER_CACHE_BREAKER = Math.floor(Math.random() * 1000000000);


class ImageCropperWithSrcSigner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      signedImageSrc: null
    };
  }

  componentDidMount() {
    const src = get(this.props.zfImage, 'src') || this.props.legacyImageSrc;
    const params = {
      // We need to add a cachebreak, but we need to ensure the request is signed properly 
      url: insertOrReplaceUrlParam(src, 'CacheBreak', TILE_CROPPER_CACHE_BREAKER)
    };
    sendRequest({
      method: 'GET',
      url: `/asset_tools/presign_url_to_hybrid_url?${serializeQueryParams(params)}`,
      onError: () => {
        const errorMessage = 'Unable to sign image URI to request image';
        loglevel.error(errorMessage);
        this.props.onCropFail(errorMessage);
      },
      onSuccess: (signedImageSrc) => {
        this.setState({ signedImageSrc });
      }
    });
  }

  render() {
    const { signedImageSrc } = this.state;

    var zfImage = null;
    if (this.props.zfImage) {
      zfImage = {
        ...this.props.zfImage,
        src: signedImageSrc
      };
    }

    return (
      signedImageSrc ?
        <ImageCropper
          {...this.props}
          legacyImageSrc={signedImageSrc}
          zfImage={zfImage}
        />
        :
        null
    );
  }
}


export default ImageCropperWithSrcSigner;